import { useEffect } from 'react'

import { getAdsInfo, getCookie } from '../utils/ads-info'

function useAdsInfo() {
  const params = new URLSearchParams(window.location.search)

  useEffect(() => {
    const adsInfo = getAdsInfo()
    const search = Object.fromEntries(params.entries())
    const cookies = ['_fbp', '_gcl_au', '_ga', '_fbc']

    cookies.forEach(key => {
      const value = getCookie(key)
      if (value) {
        search[key] = value
      }
    })

    const latestAdsInfo = { ...adsInfo, ...search }

    if (Object.keys(latestAdsInfo).length) {
      localStorage.setItem('ads_info', JSON.stringify(latestAdsInfo))
    }
  }, [])
}

export default useAdsInfo
